import AsyncComponent from "platform/component/async/AsyncComponent";

export const TradingAsync = AsyncComponent(() => {
    return import("../component/root/TradingRoot");
});

export const TradingMobileAsync = AsyncComponent(() => {
    return import("../component/root/TradingRootMob");
});
